var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{key:_vm.componentKey,staticClass:"number-button",attrs:{"fab":"","dark":"","small":"","color":_vm.color},on:{"click":function($event){return _vm.change(_vm.number)}}},[_vm._v(" "+_vm._s(_vm.number)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }